import * as React from 'react';
import Typography from '@mui/material/Typography';
import {
    Avatar,
    Link,
    Alert,
    TextField,
    Box,
    Divider
} from '@mui/material';
import { LockOutlined } from "@mui/icons-material";
import { Button } from "react-bootstrap";
import "./custom.css"
import { useState } from "react";
import { getServiceLabel } from "../globalMethods/myConfig";

const orbitron = "'Orbitron', sans-serif";

const GALAXY_BG = `
    linear-gradient(rgba(0,0,0,0.82), rgba(0,0,0,0.88)),
    url('https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=1920&q=80') center/cover no-repeat fixed
`;

const PasswordLayout = () => {

    const [email, setEmail] = useState('');
    const [message] = useState('');
    const [showMessage] = useState(false);
    const [showErrorEmail, setShowErrorEmail] = useState(false);

    const handleChangeEmail = (e) => { setEmail(e.target.value); }

    return (
        <Box sx={{ minHeight: "100vh", background: GALAXY_BG, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: orbitron, px: 2 }}>

            {/* Blue grid overlay */}
            <Box sx={{
                position: "fixed", inset: 0,
                backgroundImage: `linear-gradient(rgba(21,101,192,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(21,101,192,0.06) 1px, transparent 1px)`,
                backgroundSize: "40px 40px", pointerEvents: "none", zIndex: 0,
            }} />

            <Box sx={{
                position: "relative", zIndex: 1, width: "100%", maxWidth: 460,
                background: "rgba(5,5,15,0.85)", backdropFilter: "blur(16px)",
                border: "1px solid #1565c0", borderRadius: 3, overflow: "hidden",
                boxShadow: "0 0 60px rgba(21,101,192,0.3), 0 0 120px rgba(21,101,192,0.1)",
            }}>
                {/* Blue top bar */}
                <Box sx={{ background: "#1565c0", py: 2, px: 3, display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5 }}>
                    <Avatar sx={{ bgcolor: "#000", width: 32, height: 32 }}>
                        <LockOutlined sx={{ fontSize: 18, color: "#1e88e5" }} />
                    </Avatar>
                    <Typography sx={{ fontFamily: orbitron, fontWeight: 900, fontSize: "0.85rem", letterSpacing: 3, color: "#fff", textTransform: "uppercase" }}>
                        KM-BIZZ · RESET PASSWORD
                    </Typography>
                </Box>

                <Box sx={{ px: 4, pt: 4, pb: 4 }}>
                    <Typography sx={{ fontFamily: orbitron, fontSize: "0.6rem", letterSpacing: 3, color: "#1e88e5", textAlign: "center", mb: 1, textTransform: "uppercase" }}>
                        {getServiceLabel()}
                    </Typography>

                    <Typography sx={{ fontFamily: orbitron, fontSize: "0.6rem", letterSpacing: 1, color: "rgba(255,255,255,0.4)", textAlign: "center", mb: 4, lineHeight: 1.8 }}>
                        Enter your email address and we'll send you a link to reset your password.
                    </Typography>

                    <TextField
                        error={showErrorEmail}
                        helperText={showErrorEmail ? <label className={'text-field-label'}>This is not an Email</label> : <></>}
                        value={email} onChange={handleChangeEmail}
                        label={<label className={'text-field-label'}>Email</label>}
                        placeholder='Enter Email' type={"email"} variant="outlined" fullWidth required
                        sx={{
                            mb: 3,
                            "& .MuiOutlinedInput-root": {
                                fontFamily: orbitron, fontSize: "0.75rem", color: "#fff",
                                "& fieldset": { borderColor: "#1565c0" },
                                "&:hover fieldset": { borderColor: "#1e88e5" },
                                "&.Mui-focused fieldset": { borderColor: "#1e88e5" },
                            },
                            "& .MuiInputLabel-root": { fontFamily: orbitron, color: "rgba(255,255,255,0.4)", fontSize: "0.75rem" },
                            "& .MuiInputLabel-root.Mui-focused": { color: "#1e88e5" },
                        }}
                    />

                    <Button type='submit'
                            onClick={async () => {
                                const pattern = /.+@.+\..+/
                                if (pattern.test(email) && email.length > 0) {
                                    // await registerUser(email, password, subscriptionId, setMessage, setShowMessage)
                                } else { setShowErrorEmail(true) }
                            }}
                            variant='primary'
                            style={{ width: "100%", background: "#1565c0", border: "none", borderRadius: 6, padding: "12px 0", fontFamily: orbitron, fontWeight: 700, fontSize: "0.75rem", letterSpacing: 3, color: "#fff", textTransform: "uppercase", cursor: "pointer", boxShadow: "0 0 20px rgba(21,101,192,0.5)", marginBottom: 20 }}
                    >
                        SEND RESET LINK
                    </Button>

                    <Divider sx={{ borderColor: "rgba(21,101,192,0.2)", mb: 2.5 }} />

                    <Typography sx={{ fontFamily: orbitron, fontSize: "0.6rem", color: "rgba(255,255,255,0.4)", letterSpacing: 1, textAlign: "center", mb: 2 }}>
                        Already have an account?&nbsp;&nbsp;
                        <Link href="/" sx={{ color: "#1e88e5", textDecorationColor: "#1565c0" }}>Sign In</Link>
                    </Typography>

                    {showMessage &&
                        <Alert severity="info" sx={{ fontFamily: orbitron, fontSize: "0.65rem", background: "rgba(21,101,192,0.15)", border: "1px solid #1565c0", color: "#fff", "& .MuiAlert-icon": { color: "#1e88e5" } }}>
                            {message}
                        </Alert>
                    }
                </Box>
            </Box>
        </Box>
    );
}

export default PasswordLayout;
